module.exports = __webpack_public_path__ + "static/media/icon5.d5c15aeb.png";